import { Cookie } from "lucide-react"

import { Button } from "@/components/ui/button"
import { useConsentimentoStore } from "@/stores/consentimentoStore"

/**
 * Barra de aceitação de cookies (primeira visita). Estilo discreto, fixo no
 * canto inferior; leva ao modal para escolha detalhada por categoria.
 */
export function CookieBanner() {
  const visivel = useConsentimentoStore((s) => s.bannerVisivel)
  const aceitarTodos = useConsentimentoStore((s) => s.aceitarTodos)
  const rejeitarOpcionais = useConsentimentoStore((s) => s.rejeitarOpcionais)
  const abrirPreferencias = useConsentimentoStore((s) => s.abrirPreferencias)

  if (!visivel) return null

  return (
    <div
      role="dialog"
      aria-label="Aviso de cookies"
      className="fixed inset-x-3 bottom-3 z-[1150] animate-in fade-in slide-in-from-bottom-4 duration-300 sm:inset-x-auto sm:right-4 sm:bottom-4 sm:w-[26rem]"
    >
      <div className="overflow-hidden rounded-2xl border bg-background/95 shadow-2xl ring-1 ring-black/5 backdrop-blur supports-[backdrop-filter]:bg-background/80">
        <div className="flex items-start gap-3 p-5">
          <div className="flex size-10 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
            <Cookie className="size-5" />
          </div>
          <div className="space-y-1.5">
            <p className="text-sm font-semibold">Sua privacidade</p>
            <p className="text-sm leading-relaxed text-muted-foreground">
              Usamos cookies para manter sua sessão, guardar suas preferências (como tema
              claro/escuro) e medir o uso do sistema. Você escolhe o que habilitar.
            </p>
            <p className="text-muted-foreground text-xs leading-relaxed">
              Saiba mais na{" "}
              <a
                href="/privacidade"
                target="_blank"
                rel="noreferrer"
                className="font-medium text-primary underline underline-offset-2 hover:opacity-80"
              >
                Política de Privacidade
              </a>{" "}
              e nos{" "}
              <a
                href="/termos"
                target="_blank"
                rel="noreferrer"
                className="font-medium text-primary underline underline-offset-2 hover:opacity-80"
              >
                Termos de Uso
              </a>
              .
            </p>
          </div>
        </div>
        <div className="flex flex-col gap-2 border-t bg-muted/40 p-4 sm:flex-row sm:items-center">
          <Button variant="ghost" size="sm" className="sm:mr-auto" onClick={abrirPreferencias}>
            Personalizar
          </Button>
          <Button variant="outline" size="sm" onClick={rejeitarOpcionais}>
            Rejeitar
          </Button>
          <Button size="sm" onClick={aceitarTodos}>
            Aceitar todos
          </Button>
        </div>
      </div>
    </div>
  )
}
